import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { fromServicePermission } from '../../model/config/permissions';
import type { Permissions } from '../../model/config/permissions/types';
import { getDefaultCompanyManagedPermissions } from '../../model/permissions';
import { fetchPermissions } from '../../rest/fetch-permissions';
import type { PermissionResponse } from '../../rest/fetch-permissions/types';

const toBacklogPermissions = (response: PermissionResponse): Permissions =>
	fromServicePermission(response.boardPermissions);

export const loadPermissionsService = (boardId: string): ObservableType<Permissions> =>
	fetchPermissions(boardId, getDefaultCompanyManagedPermissions()).map(toBacklogPermissions);
